<template>
  <component-wrapper>
    <div class="teaser-big-image-fi">
      <teaser-big-image-element-fi :fields="fields" />
    </div>
  </component-wrapper>
</template>

<script>
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import TeaserBigImageElementFi from 'components/teaser/teaser-big-image-element-fi/TeaserBigImageElementFi';

export default {
  name: 'TeaserBigImageInnovationFi',
  components: {
    ComponentWrapper,
    TeaserBigImageElementFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
